import { RouteKeys } from './web-app-roputes.constants';

export const breadcrumbLabels = {
  [RouteKeys.homePage]: 'Offers',
  [RouteKeys.user]: 'User',
};
